import React, {useEffect, useState} from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {PaymentWidgetWrapper} from './PaymentWidgetWrapper';
import {classes, st} from './PaymentFlow.st.css';
import {classes as commonClasses} from '../../../common/common.st.css';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {PayNowButton} from './PayNowButton/PayNowButton';
import {RecurringPaymentInfo} from './RecurringPaymentInfo/RecurringPaymentInfo';
import {MainLoader} from '../../../common/components/Layout/MainLoader/MainLoader';
import {useControllerProps} from '../Widget/ControllerContext';
import {StartPayment} from '../../../domain/utils/analytics.utils';
import {SPECS} from '../../../common/constants';

export enum PaymentFlowDataHook {
  root = 'PaymentFlowDataHook.root',
  title = 'PaymentFlowDataHook.title',
}

export const PaymentFlow = () => {
  const {experiments} = useExperiments();
  const {
    paymentRequestStore: {sendPaymentRequestPageLoadBIEvent},
    navigationStore: {trackEvent},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const [loaded, setLoaded] = useState(false);
  const showRecurringPaymentInfo = experiments.enabled(SPECS.SupportSubscriptionDescriptionOnPaymentRequest);

  useEffect(
    () => {
      if (loaded) {
        sendPaymentRequestPageLoadBIEvent();
        trackEvent(...StartPayment);
      }
    },
    /* eslint-disable react-hooks/exhaustive-deps */ [loaded]
  );

  return (
    <div
      className={st(commonClasses.oneColumnViewPadding, classes.paymentFlowRoot)}
      data-hook={PaymentFlowDataHook.root}>
      <div className={classes.stepTitleContainer}>
        <div className={classes.stepTitle}>
          <Text
            tagName={'h2'}
            priority={TextPriority.primary}
            className={classes.titleText}
            data-hook={PaymentFlowDataHook.title}>
            {localeKeys.checkout.payment()}
          </Text>
        </div>
      </div>
      {!loaded && <MainLoader />}
      <PaymentWidgetWrapper setLoaded={setLoaded} loaded={loaded} />
      {loaded && showRecurringPaymentInfo && <RecurringPaymentInfo />}
      {loaded && <PayNowButton />}
    </div>
  );
};
